import { CA } from '../../analytics/Analytics.ts';
import { AnalyticEventCategory, AnalyticEventType } from '../../../../../shared/entity_datas/EntityDatas.ts';
import { UIReplayController } from '../../ui_replay/UIReplayController.ts';
import { socket } from '../../EntryShared.ts';
import { UIAPIEndpoints } from '../../network/UIAPIEndpoints.ts';
import { UIAjaxWrapper } from '../../network/UIAjaxWrapper.ts';
export class UIGameEndReturnToMapButtonController {
    async onClickButton() {
        // TODO remove debounce logic once ReactJS state is set up properly, UIGameEnd after UIGameReturnToStats in UIGameLayoutPortrait
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }
        this.debounceTimer = setTimeout(async ()=>{
            this.debounceTimer = null;
            await this.handleButtonClick();
        }, 100);
    }
    async handleButtonClick() {
        void CA.sendAnalyticEventOnce({
            type: AnalyticEventType.EndGameReturnToMapButton,
            category: AnalyticEventCategory.Game
        });
        const isReplay = this.uiGameManager.gameStore.getState().gameReplay.replayControls !== undefined;
        if (this.replayDataUnavailable) {
            this.toggleBetweenStatsAndMap();
        } else if (isReplay) {
            this.toggleBetweenStatsAndReplay();
        } else {
            void this.initGameEndReplay();
        }
    }
    toggleBetweenStatsAndMap() {
        const isStatsVisible = !this.gameEndController.isVisible;
        const isMapVisible = !isStatsVisible;
        this.uiGameManager.mapController.setInteractionEnabled(isMapVisible);
        this.uiGameManager.gameStore.getState().gameEnd.setIsVisible(isStatsVisible);
    }
    toggleBetweenStatsAndReplay() {
        const replayControls = this.uiGameManager.gameStore.getState().gameReplay.replayControls;
        if (replayControls == undefined) return;
        const isStatsVisible = this.gameEndController.isVisible;
        const actionBeforeEndgameScreenIsShown = replayControls.numberOfActions - 2;
        const actionIndexForEndgameScreen = replayControls.numberOfActions - 1;
        const actionIndex = isStatsVisible ? actionBeforeEndgameScreenIsShown : actionIndexForEndgameScreen;
        replayControls.onChangeActionIndex(actionIndex);
        this.uiGameManager.gameStore.getState().gameEnd.setIsVisible(!isStatsVisible);
    }
    async initGameEndReplay() {
        this.toggleBetweenStatsAndMap();
        const replayData = await this.getReplayData();
        if (replayData == undefined) {
            this.replayDataUnavailable = true;
            return;
        }
        this.startReplay(replayData);
    }
    async getReplayData() {
        const isSpectator = this.uiGameManager.gameController.isPlayerSpectator;
        const playerColor = isSpectator ? this.uiGameManager.gameController.playOrder[0] : this.uiGameManager.gameController.myColor;
        const replayDataUrl = UIAPIEndpoints.apiReplayDataFromGameId(socket.gameListener.databaseGameId, playerColor);
        const displayError = false;
        const replayDataResponse = await UIAjaxWrapper.getRequestHandler(replayDataUrl, undefined, undefined, displayError);
        if (replayDataResponse == undefined || !replayDataResponse.isSuccess) return undefined;
        const replayData = replayDataResponse.json.data;
        replayData.rankedUserStates = this.gameEndController.rankedUserStates;
        return replayDataResponse.json.data;
    }
    startReplay(replayData) {
        var _this_uiGameManager_gameStore_getState_gameReplay_replayControls;
        this.uiGameManager.resetGameUIToRebuildOnReconnect();
        this.gameEndController.destroy();
        // Temporary fix for Discord, overwrite PlayerStates with the ones used in the game since these have the correct discord usernames
        const recentPlayerStates = this.uiGameManager.gameController.getPlayerValidators().map((playerValidator)=>playerValidator.userState);
        replayData.playerUserStates = recentPlayerStates;
        const isLiveGame = true;
        const replayController = new UIReplayController(replayData, socket.actionController, isLiveGame);
        const actionIndexBeforeEndgame = replayController.actionIndexForEndgame - 1;
        (_this_uiGameManager_gameStore_getState_gameReplay_replayControls = this.uiGameManager.gameStore.getState().gameReplay.replayControls) === null || _this_uiGameManager_gameStore_getState_gameReplay_replayControls === void 0 ? void 0 : _this_uiGameManager_gameStore_getState_gameReplay_replayControls.onChangeActionIndex(actionIndexBeforeEndgame);
    }
    constructor(uiGameManager, gameEndController){
        this.replayDataUnavailable = false;
        this.debounceTimer = null;
        this.uiGameManager = uiGameManager;
        this.gameEndController = gameEndController;
    }
}
